
if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.idInput = this.form.querySelector('[name="id"]');
        if (this.idInput) {
          this.idInput.disabled = false;
        }

        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        this.variantSelects = this.form.querySelectorAll('input[name^="options["]');
        if (this.variantSelects.length) {
          this.variantSelects.forEach(input => {
            input.addEventListener('change', this.updateVariantId.bind(this));
          });
          this.updateVariantId(); // set on load
        }

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    updateVariantId() {
      const options = Array.from(this.form.querySelectorAll('input[name^="options["]:checked'))
        .map(input => input.value);

      let variants = [];
      if (window.productData && Array.isArray(window.productData.variants)) {
        variants = window.productData.variants;
      }

      const matchingVariant = variants.find(v =>
        JSON.stringify(v.options) === JSON.stringify(options)
      );

      if (matchingVariant) {
        if (this.idInput) {
          this.idInput.value = matchingVariant.id;
        }
        
        // Update URL with variant ID
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState(null, '', currentUrl.toString());
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();
      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

            const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);



const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();



        if (data.status) this.setErrorMsgState(data.message || data.description);

        // Handle quantity limitation errors (422) with safe retry
        if (!response.ok && response.status === 422) {

          
          // Check if this is a quantity limitation error
          if (data.description && (data.description.includes('quantity') || data.description.includes('stock'))) {
            const variantId = formData.get('id');
            const requestedQty = parseInt(formData.get('quantity')) || 1;
            

            
            // Find variant in productData to validate availability
            const currentVariant = window.productData?.variants?.find(v => v.id == variantId);

            
            // Only retry if user requested more than 1 item
            if (requestedQty > 1) {
              if (currentVariant && currentVariant.available) {

                
                // Try adding just 1 item (safest approach when getting quantity errors)
                const retryFormData = new FormData(this.form);
                retryFormData.set('quantity', '1');
                

                
                const retryResponse = await fetch(theme.routes.cartAdd, {
                  ...fetchRequestOpts,
                  body: retryFormData
                });
                const retryData = await retryResponse.json();
                

                
                if (retryResponse.ok) {

                  // Success! Show user-friendly message
                  const userFriendlyMessage = `Only 1 item was added to your cart due to availability.`;
                  this.setErrorMsgState(userFriendlyMessage);
                  
                  // Continue with success flow
                  if (theme.settings.afterAtc === 'page') {
                    setTimeout(() => { window.location.href = theme.routes.cart; }, 300);
                  } else {
                    ProductForm.updateCartIcon(retryData);
                    const quickAddDrawer = this.closest('quick-add-drawer');
                    if (quickAddDrawer) quickAddDrawer.addedToCart();
                    if (this.cartDrawer) {
                      setTimeout(() => {
                        this.cartDrawer.renderContents(retryData, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
                      }, 700);
                    }
                  }
                  
                  this.submitBtn.classList.add('is-success');
                  this.submitBtn.removeAttribute('aria-disabled');
                  setTimeout(() => {
                    this.submitBtn.classList.remove('is-loading', 'is-success');
                    $.getScript('https://wrapin.prezenapps.com/public/js/wrapin-drawer.js');
                  }, 1400);
                  
                  return; // Success, exit early
                }
              }
            }
          }
          // If we get here, show appropriate error message

          throw new Error(data.message || data.description || response.status);
        }

        if (!response.ok) throw new Error(response.status);



        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => { window.location.href = theme.routes.cart; }, 300);
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          if (this.cartDrawer) {
            setTimeout(() => {
              this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
            }, 700);
          }
        }
      } catch (error) {
        this.setErrorMsgState(error.message || 'An error occurred.');
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading', 'is-success');
          $.getScript('https://wrapin.prezenapps.com/public/js/wrapin-drawer.js');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
